/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { tryDefine } from '@tylertech/forge-core';
import { AVATAR_TAG_NAME, AvatarComponent } from './avatar';
export * from './avatar';
export * from './avatar-constants';
export function defineAvatarComponent() {
    tryDefine(AVATAR_TAG_NAME, AvatarComponent);
}
